<template>
    <div class="bg-[#2E2F2F] border-[1px] border-[#383939] rounded-[13px] w-full pb-[10px]">
        <div class="text-[#C59014] text-[20px] font-bold text-center mt-[12px]">
            Тижневий цикл
        </div>

        <div class="flex mt-[10px] px-[10px]">
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px] shadow-[#C59014]">
                <div :class="{
                    'current-day-flag': shortDay == 'ПН'
                }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[20px] text-center">ПН</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Направленість: <b class="text-[#C59014]">Аеробна</b></div>
                        <div class="text-[12px] text-center">Навантеженість: <b class="text-[#C59014]">Середня</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">Профілактика, укріплення. Індивідуальна, групова техніка тактика</div>
                </div>
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{
                    'current-day-flag': shortDay == 'ВТ'
                }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[20px] text-center">ВТ</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Направленість: <b class="text-[#C59014]">Швидкісно-силова</b></div>
                        <div class="text-[12px] text-center">Навантеженість: <b class="text-[#C59014]">Велика</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">Єдиноборства<br>1x1;2x2;3x3+N</div>
                </div>
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{
                    'current-day-flag': shortDay == 'СР'
                }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[20px] text-center">СР</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Направленість: <b class="text-[#C59014]">Спеціальна витривалість</b></div>
                        <div class="text-[12px] text-center">Навантеженість: <b class="text-[#C59014]">Велика</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">Позиційні ігри<br>8x8,9x9,10x10</div>
                </div>
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{
                    'current-day-flag': shortDay == 'ЧТ'
                }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[20px] text-center">ЧТ</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Направленість: <b class="text-[#C59014]">Техніко-тактична з елементами швидкості</b></div>
                        <div class="text-[12px] text-center">Навантеженість: <b class="text-[#C59014]">Середня</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">Групова-командна тактика, 10x10 (Модель гри). Стандартні положення(кутові, штрафні, аути-атака).</div>
                </div>
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{
                    'current-day-flag': shortDay == 'ПТ'
                }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[20px] text-center">ПТ</div>
                    <div class="mt-[4px] flex flex-col items-center justify-center">
                        <div class="text-[12px] text-center">Командна тактика</div>
                        <div class="text-[12px] text-center">Навантеженість: <b class="text-[#C59014]">Мала</b></div>
                    </div>
                    <div class="text-[12px] text-center mt-[4px]">Групова-командна тактика 10х10 (Модель гри). Стандартні положення (кутові, штрафні, аути-оборона)</div>
                </div>
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                <div :class="{
                    'current-day-flag': shortDay == 'СБ'
                }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[20px] text-center">СБ</div>
                    <div class="font-bold text-center flex justify-center mt-[60px]">
                        ГРА
                    </div>
                </div>
            </div>
            <div class="w-[14.28%] px-[7px]">
                <div :class="{
                    'current-day-flag': shortDay == 'НД'
                }" class="rounded-[10px] h-full">
                    <div class="text-[#C59014] font-bold text-[20px] text-center">НД</div>
                    <div class="font-bold text-center flex justify-center mt-[60px]">
                        ВИХІДНИЙ
                    </div>
                </div>
            </div>
        </div>

        <div v-if="openFlag" class="flex mt-[10px] px-[10px]">
            <div class="w-[14.28%] border-r-[1px] text-[12px] text-center border-[#C59014] px-[7px]">
                <b class="text-[#C59014]">- Технічний блок -</b><br>
                <b>- АКЦЕНТ -</b><br>
                Техніко-тактичні дії з мʼячем
                в малих групах.
                (прийом, передача, ведення
                мʼяча, відкривання, гра у стінку, на третього, фінти)<br><br>
                <b>- РОБОТА У ГРУПАХ -</b><br><br>
                <b class="text-[#C59014]">- Відпрацювання
                Індивідуальних та групових тактичних взаємодій в обороні -<br>
                ПРИНЦИПИ ГРИ В ОБОРОНІ-(нижній, середній блок)
                Навчальна та ігрова форма</b><br>
                <b>- АКЦЕНТ -</b><br>
                -Реакція на відкритий, закритий мяч, страховка, зміщення, компактн ість в лінії, гра на
                випередження, перехвати, гра у
                створі, контроль гравців при фланговій атаці, при другому темпі - у
                двійках,трійках,четвірках. -
                загравання 6х4.7х5;8х6-
                Навчальна та ігрова форма<br><br>

                <b class="text-[#C59014]">Відпрацювання Індивідуальних та групових тактичних взаємодій в атаці</b><br>
                <b>- АКЦЕНТ -</b><br>
                Удари на виконання, флангові завершення, індивідуальні групові тактичні взаємодії в атаці (відкривання, гра у стінку, схрещування, гра на третього).<br><br>
                
                <b class="text-[#C59014]">ЗАГРАВАННЯ</b><br>
                <b>- ФУТБОЛ -</b><br>
                (Із завданнями)
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px] text-center text-[12px]">
                <b class="text-[#C59014]">Інтенсивність за рахунок організації тренувального процесу</b><br><br>
                <b>- Технічний блок -</b><br>
                Відпрацювання техніко-тактичних дій з м’ячем<br>
                Індивідуальні та групові техніко-тактичні взаємодії в обороні й атаці (у малих групах)<br><br>
                <b class="text-[#C59014]">- ЄДИНОБОРСТВА -</b><br>
                <b class="text-[#C59014]">АКЦЕНТ НА КІЛЬКІСТЬ УДАРІВ</b><br>
                Дуелі: 1x1; 2x2; 3x3.
                Швидкі атаки з реалізації численої переваги 2х1; 3х2; 4х3<br><br>
                Відборів індивідуальних, групових<br><br>
                <b class="text-[#C59014]">ЗАГРАВАННЯ</b><br>
                <b>- ФУТБОЛ -</b><br>
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px] text-[12px] text-center">
                <b class="text-[#C59014]">Інтенсивність за рахунок організації тренувального процесу</b><br><br>

                <b>Технічний блок</b><br><br>

                <b>Відпрацювання техніко-тактичних дій з м’ячем</b><br><br>

                <b class="text-[#C59014]">- Позиційні ігри -</b><br><br>

                <b>Ігрові вправи орієнтовані на:</b><br>
                <b>- Позиційне володіння м'ячем (Відпрацювання структури з володіння м'ячем)</b><br>
                <b>- Реалізацію численої більшості</b><br>
                <b>- Переходи в атаку-оборону (реація на втрату м'яча на заволодіння м'ячем)</b><br>
                <b>- Орієнтація на гру 1х1</b><br>
                <b>- Вправи на просторі</b><br>
                <b>- СТВОРЕННЯ УМОВ та КОНТРОЛЬ БЕЗПЕРЕРВНОСТІ при виконанні ІГРОВИХ ВПРАВ</b><br><br>
                <b>- ДВОСТОРОННЯ ГРА ІЗ ЗАВДАННЯМИ -</b><br>
                Серія - без стандартів (безперервність)<br>
                Серія - відпрацювання стандартів при повному контакті<br>
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px] text-[12px] text-center">
                <b>Емоційні ігри + технічний блок</b><br><br>

                <b>2 групи</b><br>

                <b class="text-[#C59014]">1 - Індивідуальні, групові дії в обороні</b><br>
                <b>- АКЦЕНТ -</b><br>
                володіння м'ячем, прийоми, передачі, активна позиція, просування мʼяча, взаємодія в лінії<br><br>

                <b class="text-[#C59014]">2 - Індивідуальні, групові дії в атаці</b><br>
                <b>- АКЦЕНТ -</b><br>
                Удари на виконання, флангові завершення, індивідуальні групові тактичні взаємодії в атаці (відкривання, гра у стінку, схрещування, гра на третього)<br><br>

                <b>- КОМАНДНА ТАКТИКА -</b><br>
                ПОЧАТОК АТАК (10х0 або в чисельній перевазі) - ВИХІД від воріт (схемат - варіанти) з переходом у швидку атаку з завершенням. Моделювання групового пресингу<br>
                ПОЧАТОК АТАК (10х0 або в чисельній перевазі) - в СЕРЕДНІЙ зоні (схемат-варіанти), подолання високого блоку з переходом у швидку атаку.<br>
                СТАНДАРТИ (атака-оборона)
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]  text-[12px] text-center">
                <b>- Технічний блок -</b><br><br>

                <b>Відпрацювання техніко-тактичних дій з м'ячем</b><br><br>

                <b>МОДЕЛЬ ГРИ</b><br>
                <b>ПОЧАТОК АТАК - ВИХІД від воріт-моделювання. Моделювання групового пресингу - ТАКТИЧНІ ЗАГОТОВКИ</b>
                <b>ПОЧАТОК АТАК - в СЕРЕДНІЙ зоні, - МОДЕЛЮВАННЯ СТАНДАРТИ (атака-оборона)</b><br><br>

                <b>КОМАНДНА СТРУКТУРА У ГРІ в ОБОРОНІ - в АТАЦІ 10х0</b><br><br>

                <b class="text-[#C59014]">ЗАГРАВАННЯ</b><br>
                <b>- ФУТБОЛ -</b><br>
            </div>
            <div class="w-[14.28%] border-r-[1px] border-[#C59014] px-[7px]">
                
            </div>
            <div class="w-[14.28%] px-[7px] text-center font-bold">
                САМОАНАЛІЗ ГРИ
            </div>
        </div>

        <div class="flex justify-center mt-[20px]">
            <div v-if="!openFlag" @click="openFlag = true" class="cursor-pointer">
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 0.75L6.04289 6.04289C6.37623 6.37623 6.54289 6.54289 6.75 6.54289C6.95711 6.54289 7.12377 6.37623 7.45711 6.04289L12.75 0.75" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div v-else @click="openFlag = false" class="cursor-pointer">
                <svg style="transform: rotate(180deg);" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 0.75L6.04289 6.04289C6.37623 6.37623 6.54289 6.54289 6.75 6.54289C6.95711 6.54289 7.12377 6.37623 7.45711 6.04289L12.75 0.75" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'

export default {
    name: 'week-trainer-cycle',

    setup() {
        const openFlag = ref(false)
        const days = ['НД', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'];

        const today = new Date();
        const dayOfWeek = today.getDay(); // 0 (воскресенье) → 6 (суббота)

        const shortDay = days[dayOfWeek];

        return {
            openFlag,
            shortDay
        }
    }
}
</script>
<style lang="scss">
.current-day-flag {
  box-shadow:
    inset 0 -20px 10px -10px rgba(197, 144, 20, 0.35);
}


</style>